module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-camisa-uniforme-personalizado-staff.3dee32a2.jpg";